module.exports = __webpack_public_path__ + "static/media/dol-l.b64f7117.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/ResizableProduct/images/dol-l.png
// module id = 437
// module chunks = 0